import {
  Button,
  SkeletonLoader,
  SmartTableColumn,
  SmartTableDataItem,
} from '@toggle/design-system';
import React from 'react';

import { SharedTable } from '../shared-table/SharedTable';
import * as S from './SectionBase.styles';

export interface SectionBaseProps<T> {
  title: string;
  onExpand?: () => void;
  tableData?: SmartTableDataItem<T>[];
  tableColumns?: SmartTableColumn<T>[];
  isFetching: boolean;
  onRowClick?: (item: SmartTableDataItem<T>) => void;
}

export const SectionBase = <T extends {}>({
  title,
  tableData = [],
  tableColumns = [],
  onExpand,
  isFetching,
  onRowClick,
}: SectionBaseProps<T>) => {
  return (
    <S.Root>
      <S.HeaderWrapper>
        <S.Title>{title}</S.Title>
        <Button
          variant="tertiary"
          iconName="Expand"
          size="small"
          onClick={() => onExpand?.()}
        />
      </S.HeaderWrapper>
      {isFetching ? (
        <S.LoadingSkeletonWrapper>
          <SkeletonLoader areas={S.loadingSkeletonAreas} />
        </S.LoadingSkeletonWrapper>
      ) : (
        <SharedTable
          tableData={tableData}
          tableColumns={tableColumns}
          onRowClick={onRowClick}
        />
      )}
    </S.Root>
  );
};
